import React, { ReactNode, useState } from 'react';
import { SuggesterPopover, SuggesterPopoverProps } from './SuggesterPopover';

export type SuggestVariablesProps = {
  children: ReactNode;
} & Omit<SuggesterPopoverProps, 'open' | 'anchorEl' | 'onClose'>;

/**
 * Reusable component for suggesting variables in different contexts.
 * Handles popover management and variable insertion.
 */
export const SuggestVariables = ({
  children,
  ...props
}: SuggestVariablesProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // .blur() solves problem of selecting a variable to focused editor
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setAnchorEl(null);
  };

  const anchorElement = React.cloneElement(
    children as React.ReactElement<Record<string, unknown>>,
    {
      onClick: handleClick,
    }
  );

  return (
    <>
      {anchorElement}
      <SuggesterPopover
        {...props}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
      />
    </>
  );
};
